import React from 'react';
import {
    itemStyle,
    itemCol1Style,
    itemCol2Style,
    itemCol3Style,
    itemTextStyle
} from './DropdownStyles';

const DropdownItem = ({ id, value, item, onSelect, backgroundColor }) => {
    const handleHoverEnter = (e) => {
        e.currentTarget.style.backgroundColor = 'rgba(20,251,255,0.15)';
    };
    const handleHoverLeave = (e, colour) => {
        e.currentTarget.style.backgroundColor = colour;
    };

    return (
        <div
            id={id}
            style={{
                ...itemStyle,
                backgroundColor: backgroundColor,
                ...(item.id !== value && { cursor: 'pointer' })
            }}
            onMouseEnter={(e) => item.id !== value && handleHoverEnter(e)}
            onMouseLeave={(e) =>
                item.id !== value && handleHoverLeave(e, backgroundColor)
            }
            onClick={(e) => item.id !== value && onSelect(e, item.id)}
        >
            <div style={itemCol1Style}> &nbsp;</div>
            <div style={{ ...itemCol2Style, textAlign: 'left' }}>
                <label
                    style={{
                        ...itemTextStyle,
                        ...(item.id === value && {
                            color: '#A6A6A6',
                            cursor: 'default'
                        })
                    }}
                >
                    {item.name}
                </label>
            </div>
            <div style={itemCol3Style}>&nbsp;</div>
        </div>
    );
};

export default DropdownItem;
